<template>
  <el-table :data="tableData" class="egl-table other-purchase-table" stripe :span-method="spanMethod">
    <el-table-column :label="$locale('global.cinemaName')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.cinemaId" :placeholder="$locale('accountPayable.placeholder.choose')" @change="getOtherGoodList_fn(scope.$index)" clearable>
          <el-option v-for="item in cinemaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.customerName')">
      <template slot-scope="scope">
        <!-- <el-select v-model="scope.row.clientId" :placeholder="$locale('accountPayable.placeholder.choose')" @change="setProp" :filterable="true">
          <el-option v-for="item in clientList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->
        <!-- <template v-if="$attrs.isOpen">
          <remote-select
            :ref="`clientComp${scope.$index}`"
            type="client"
            :isMultiple="false"
            v-model="scope.row.clientId"
            :formValue.sync="scope.row.clientId"
            :actionType="$attrs.actionType === 'registration' ? 'create' : 'edit'"
          />
        </template> -->
        <RemoteSelectV2
          ref="selectV2"
          type="client"
          :list="comClientList"
          :fields="['id', 'name']"
          v-model="scope.row.clientId"
          :isMultiple="false"
          :formValue.sync="scope.row.clientId"
          @setList="arr => comClientList = arr"
        />
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.name')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.otherGoodsInfoId" @change="checkOtherGood(scope.$index)" :placeholder="$locale('accountPayable.placeholder.choose')">
          <el-option v-for="item in otherGoodList[scope.$index]" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.detailedSummary')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.otherGoodsInfo.comment"
          v-if="scope.$index < tableData.length - 1"
          :placeholder="$locale('accountPayable.placeholder.input')"
          @input="setProp"
        ></el-input>
        <span v-else>{{ scope.row.otherGoodsInfo.comment }}</span>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.unitPrice')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.otherGoodsInfo.price"
          @input="inputNumber(scope.$index, 'price')"
          @blur="inputBlur(scope.$index, 'price')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.quantity')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.otherGoodsInfo.inventory"
          @input="inputNumber(scope.$index, 'inventory')"
          @blur="inputBlur(scope.$index, 'inventory')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.unit')">
      <template slot-scope="scope">
        <el-input v-model="scope.row.otherGoodsInfo.unit" @input="setProp"></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.th.recordAmount')" prop="priceTotal" align="right"></el-table-column>

    <el-table-column>
      <template slot-scope="scope">
        <div class="handle">
          <el-button class="handle-btn egl-btn-white" @click="removeTr(scope.$index)" v-if="tableData.length > 2 && scope.$index != tableData.length - 1">
            <i class="el-icon-minus"></i>
          </el-button>
          <el-button class="handle-btn egl-btn-white" @click="addTr" v-if="scope.$index == tableData.length - 2">
            <i class="el-icon-plus"></i>
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { createOtherPurchaseData, createNullTr, formatOtherPurchaseData, reverseData } from "@/assets/js/accountPayable.js";
import { getOtherGoodList } from "@/helpers/service/api/accountPayable.js";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";

export default {
  name: "AccountPayableOtherPurchaseTable",
  data() {
    return {
      tableData: [],
      otherGoodList: [ [] ],
      gotListCinemaId: [],
      apiOtherGoodList: [],
      comClientList: [],
    };
  },
  methods: {
    spanMethod({ rowIndex, columnIndex }) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };
      let dataLength = this.tableData.length - 1;

      if (rowIndex == dataLength) {
        if (columnIndex == 3 || columnIndex == 7) {
          obj.colspan = 4;
        } else if (columnIndex == 8) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj;
    },
    getOtherPurchase() {
      let { data, total } = this.getTotal();
      return { data, total };
    },
    checkOtherGood(index) {
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      let id = tableData[index].otherGoodsInfoId;

      for (let i = 0; i < this.otherGoodList[index].length; i++) {
        if (id == this.otherGoodList[index][i].id) {
          tableData[index].otherGoodsInfo = JSON.parse(JSON.stringify(this.otherGoodList[index][i]));
          tableData[index].priceTotal = (tableData[index].otherGoodsInfo.price * tableData[index].otherGoodsInfo.inventory).toLocaleString();
          break;
        }
      }

      this.tableData = tableData;
      this.setProp();
    },
    addTr() {
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      let nullTr = createNullTr();

      tableData.splice(tableData.length - 1, 0, nullTr);

      this.tableData = formatOtherPurchaseData(tableData);
      this.otherGoodList = [...this.otherGoodList, []];
    },
    removeTr(index) {
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      let otherGoodList = [ ...this.otherGoodList ];

      tableData.splice(index, 1);
      otherGoodList.splice(index, 1);

      this.tableData = formatOtherPurchaseData(tableData);


      this.$nextTick(() => {
        this.tableData.forEach((item, idx) => {
          if (idx < this.tableData.length - 1) {
            this.$refs[`clientComp${idx}`].getListForParent();
          }
        });
      });
      this.otherGoodList = otherGoodList;
      this.setProp();
    },
    setProp() {
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      let { data, total } = this.getTotal();
      let tableTotal = "-";

      if (this.$listeners.callFatherFn) {
        this.$emit("callFatherFn", { data, total });
      }

      // if (total > 0) {
      //   tableTotal = total;
      // }

      tableTotal = total;

      // if (tableTotal != "-") {
      //   tableData[tableData.length - 1].priceTotal = tableTotal.toLocaleString();
      // } else {
      //   tableData[tableData.length - 1].priceTotal = tableTotal;
      // }

      tableData[tableData.length - 1].priceTotal = tableTotal.toLocaleString();

      this.tableData = tableData;
    },
    getTotal() {
      let data = JSON.parse(JSON.stringify(this.tableData));
      let newData = [];
      let total = 0;

      data.length--;
      data = reverseData(data);

      data.map(obj => {
        // if (obj.otherGoodsInfo.price > 0 && obj.otherGoodsInfo.inventory > 0) {
        //   obj.priceTotal = obj.otherGoodsInfo.price * obj.otherGoodsInfo.inventory;
        // } else {
        //   obj.priceTotal = 0;
        // }

        obj.priceTotal = obj.otherGoodsInfo.price * obj.otherGoodsInfo.inventory;
        obj.needPayAmount = obj.priceTotal;

        total += obj.priceTotal;

        if (obj.cinemaId && obj.clientId && obj.otherGoodsInfoId) {
          newData.push(JSON.parse(JSON.stringify(obj)));
        }

        return obj;
      });

      return { data: newData, total: total };
    },
    inputNumber(index, keyName) {
      let data = JSON.parse(JSON.stringify(this.tableData));
      // let num = data[index].otherGoodsInfo[keyName].toString().replace(/[^\d]/g, "");
      let num = isNaN(parseInt(data[index].otherGoodsInfo[keyName].toString())) ? data[index].otherGoodsInfo[keyName].toString() :
        parseInt(data[index].otherGoodsInfo[keyName].toString());
      let anotherNum = 0;
      let trueNum = 0;

      if (keyName === "price") {
        anotherNum = parseInt(data[index].otherGoodsInfo.inventory.toString());
      } else {
        anotherNum = parseInt(data[index].otherGoodsInfo.price.toString());
      }
      // if (keyName == "price") {
      //   anotherNum = parseInt(data[index].otherGoodsInfo.inventory.toString().replace(/[^\d]/g, "")) || 0;
      // } else {
      //   anotherNum = parseInt(data[index].otherGoodsInfo.price.toString().replace(/[^\d]/g, "")) || 0;
      // }

      
      // if (num != "") {
      //   num = parseInt(num) || "";
      // }

      trueNum = typeof(num) == "number" ? num : 0;

      data[index].otherGoodsInfo.priceTotal = (num * anotherNum).toLocaleString();
      data[index].priceTotal = (trueNum * anotherNum).toLocaleString();
      data[index].otherGoodsInfo[keyName] = num;

      this.tableData = data;
      this.setProp();
    },
    inputBlur(index, keyName) {
      let data = JSON.parse(JSON.stringify(this.tableData));
      let num = data[index].otherGoodsInfo[keyName];

      num = parseInt(num) || "-";
      // num = num != "-" ? num.toLocaleString() : num;
      data[index].otherGoodsInfo[keyName] = num;

      this.tableData = data;
      this.setProp();
    },
    getOtherGoodList_fn(index) {
      let { cinemaId } = this.tableData[index];
      let cinemaIdIndex = -1;
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      let otherGoodList = JSON.parse(JSON.stringify(this.otherGoodList));

      for (let i = 0; i < this.apiOtherGoodList.length; i++) {
        if (this.apiOtherGoodList[i].cinemaId == cinemaId) {
          cinemaIdIndex = i;
          break;
        }
      }

      if (cinemaId != "") {
        if (cinemaIdIndex < 0) {
          getOtherGoodList(cinemaId).then(res => {
            otherGoodList[index] = res.data.data;
            this.otherGoodList = otherGoodList;
            this.apiOtherGoodList.push({
              cinemaId: cinemaId,
              list: [ ...res.data.data ],
            });
          }).catch(err => {});
        } else {
          otherGoodList[index] = JSON.parse(JSON.stringify(this.apiOtherGoodList[cinemaIdIndex].list));
          this.otherGoodList = otherGoodList;
        }

        tableData[index].otherGoodsInfo = {
          comment: "",
          price: 0,
          inventory: 0,
          unit: "-",
        };
        tableData[index].otherGoodsInfoId = "";
        tableData[index].priceTotal = "0";
      } else {
        otherGoodList[index] = [];
        this.otherGoodList = otherGoodList;
        tableData[index] = createNullTr();
      }

      this.tableData = tableData;
      this.setProp();
    },
    getTableOtherGoodList(table) {
      const that = this;
      for (let i = 0; i < table.length; i++) {
        let cinemaId = table[i].cinemaId || "";

        if (cinemaId) {
          getOtherGoodList(cinemaId).then(res => {
            let otherGoodList = [ ...that.otherGoodList ];

            otherGoodList[i] = res.data.data;

            that.otherGoodList = otherGoodList;
            this.apiOtherGoodList[i] = {
              cinemaId: cinemaId,
              list: [ ...res.data.data ],
            };
          }).catch(err => {});
        }
      }
    },
  },
  mounted() {
    let tableData = formatOtherPurchaseData(createOtherPurchaseData(this.propData));

    this.getTableOtherGoodList(tableData);
    this.tableData = tableData;
  },
  props: {
    propData: {
      type: Array,
      default: () => [],
    },
    cinemaList: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    }
  },
  watch: {
    propData() {
      let tableData = formatOtherPurchaseData(createOtherPurchaseData(this.propData));

      this.getTableOtherGoodList(tableData);
      this.tableData = tableData;
    }
  },
  components: {
    RemoteSelectV2,
  }
};
</script>
